function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pending") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11.25a1.25 1.25 0 1 0-.885-2.135A1.25 1.25 0 0 0 6 11.25zm4 0a1.246 1.246 0 1 0-.885-.365 1.2 1.2 0 0 0 .885.365zm4 0a1.246 1.246 0 1 0-.885-.365 1.2 1.2 0 0 0 .885.365zM10 18a7.8 7.8 0 0 1-3.1-.625A8.037 8.037 0 0 1 2.625 13.1 7.8 7.8 0 0 1 2 10a7.775 7.775 0 0 1 .625-3.115A8.066 8.066 0 0 1 6.9 2.625 7.8 7.8 0 0 1 10 2a7.775 7.775 0 0 1 3.115.625 8.1 8.1 0 0 1 4.26 4.26A7.775 7.775 0 0 1 18 10a7.8 7.8 0 0 1-.625 3.1 8.066 8.066 0 0 1-4.26 4.271A7.775 7.775 0 0 1 10 18z",
    transform: "translate(2 3)",
    style: {
      fill: "#e9b73e"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.f8c4cc0cc605f73f679ce55914259d5c.svg";
export { ForwardRef as ReactComponent };